import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import {
  SIDEBAR_WIDGET_BORDER_COLOR,
  SIDEBAR_WIDGET_CARD_SX,
  SIDEBAR_WIDGET_TITLE_SX,
} from "./sidebarWidgetStyles";

const BORDER = SIDEBAR_WIDGET_BORDER_COLOR;
const MUTED = "#98A2B3";
const TEXT = "#344054";
const PURPLE = "#9C4FFF";

const footerLinkSx = {
  fontFamily: "Be Vietnam Pro",
  fontSize: 14,
  fontWeight: 500,
  color: PURPLE,
  cursor: "pointer",
  userSelect: "none",
  "&:hover": {
    opacity: 0.88,
  },
};

export default function JobOwnerCard({
  ownerName = "-",
  ownerRole = "Team Manager",
  onAddOwner,
  onEditOwner,
}) {
  const handleAddOwner = onAddOwner || onEditOwner;
  const handleEditOwner = onEditOwner || onAddOwner;

  return (
    <Box
      sx={{
        ...SIDEBAR_WIDGET_CARD_SX,
        px: 4,
        py: 4,
      }}
    >
      <Typography
        sx={{
          ...SIDEBAR_WIDGET_TITLE_SX,
        }}
      >
        Owner
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr) 44px",
            alignItems: "center",
            columnGap: 2,
          }}
        >
          <Typography sx={{ fontSize: 13, color: MUTED, fontFamily: "Be Vietnam Pro" }}>
            Name
          </Typography>
          <Typography sx={{ fontSize: 13, color: MUTED, fontFamily: "Be Vietnam Pro" }}>
            Role
          </Typography>
          <Typography
            sx={{
              fontSize: 13,
              color: MUTED,
              fontFamily: "Be Vietnam Pro",
              textAlign: "right",
            }}
          >
            Actions
          </Typography>
        </Box>

        <Box sx={{ mt: 1.25, borderTop: `1px solid ${BORDER}` }} />

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr) 44px",
            alignItems: "center",
            columnGap: 2,
            py: 1.65,
            borderBottom: `1px solid ${BORDER}`,
          }}
        >
          <Typography
            noWrap
            sx={{
              fontFamily: "Be Vietnam Pro",
              fontSize: 14,
              fontWeight: 500,
              color: TEXT,
            }}
          >
            {ownerName || "-"}
          </Typography>
          <Typography
            noWrap
            sx={{
              fontFamily: "Be Vietnam Pro",
              fontSize: 14,
              fontWeight: 500,
              color: TEXT,
            }}
          >
            {ownerRole || "Team Manager"}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton
              onClick={handleEditOwner}
              aria-label="Manage owner"
              sx={{
                width: 28,
                height: 28,
                color: PURPLE,
              }}
            >
              <AssignmentOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          mt: 4.25,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1.6,
        }}
      >
        <Typography onClick={handleAddOwner} sx={footerLinkSx}>
          Add New
        </Typography>
        <Typography sx={{ fontSize: 14, color: TEXT }}>|</Typography>
        <Typography onClick={handleEditOwner} sx={footerLinkSx}>
          Edit
        </Typography>
      </Box>
    </Box>
  );
}
